import React from "react";
import { CalculatorForm } from "../components";

function Calculator() {
  return (
    <>
      <CalculatorForm />
    </>
  );
}

export default Calculator;
